//@import dependencies
import React, {useState} from 'react'
import { useTranslation } from 'react-i18next'
//@end

//@import components
import SchedulingSkeleton from './schedulingExtendSkeleton'
import DataTableComponent from 'app_components/commons/dataTable'
import AlertComponent from 'app_components/commons/alert'
//@end

// @import hooks
// @end

// @INFO Import types
import { IPagination } from 'app_types/pagination/paginationTypes'
// @end

// @INFO Import services
// @end

// @INFO Import Styles
import './../schedulingExtendModule.scss'
import CourseSchedulingScreenFormFilterLayout from 'app_components/screens/admin/courseScheduling/components/courseSchedulingScreenFormFilterLayout'
import { useForm } from 'react-hook-form'
import TooltipComponent from 'app_components/commons/TooltipComponent/TooltipComponent'
import ModalAttached from 'app_components/modules/ModalAttached/ModalAttached'
import { ICourseSchedulingListItem } from 'app_types/admin/courseScheduling/courseSchedulingTypes'
import { AiOutlineCloudDownload } from 'react-icons/ai'

// @ADD Component types
interface ISchedulingExtendModuleLayoutProps {
  status: null | 'loading' | 'error'
  schedulingData: Array<any>
  pagination: IPagination
  onPageChange: (page: number) => void
  fetchSchedulingExtendData: (params: any) => void;
}

const SchedulingExtendModuleLayout: React.FC<ISchedulingExtendModuleLayoutProps> = (props) => {

  const { t } = useTranslation()
  const searchForm = useForm();
  const [openBusinessReport, updateOpenBusinessReport] = useState<ICourseSchedulingListItem | undefined>(undefined);
  const [openPartialReport, updateOpenPartialReport] = useState<any | undefined>(undefined);


  const handleOnSearch = async (data?: any) => {
    props.fetchSchedulingExtendData({page: 1, ...data});
  }

  const handleClickBusinessReport = (courseScheduling: any) => {
    updateOpenBusinessReport(courseScheduling);
  }

  const handleClickPartialReport = (courseScheduling: any) => {
    updateOpenPartialReport(courseScheduling);
  }

  return(
    <div className='scheduling_extend-module'>
      <div className="title">
        {t("modules.scheduling_extend_module.title")}
      </div>
      <hr />
      <div className="table-format-standar main-table">
        <CourseSchedulingScreenFormFilterLayout
          searchForm={searchForm}
          onSearch={handleOnSearch}
          fields={['start_date', 'end_date']}
          className='form-search-module'
        />
        {props.status === 'loading' ? (
          <SchedulingSkeleton />
        ): (
          <>
          {props.schedulingData && Array.isArray(props.schedulingData) && props.schedulingData.length > 0 ? (
            <>
              <DataTableComponent
                data={props.schedulingData}
                headerKeys={[
                  `${t('modules.scheduling_extend_module.headers.service')}`,
                  `${t('modules.scheduling_extend_module.headers.program_code')}`,
                  `${t('modules.scheduling_extend_module.headers.program_name')}`,
                  `${t('modules.scheduling_extend_module.headers.duration')}`,
                  `${t('modules.scheduling_extend_module.headers.scheduling_mode')}`,
                  // `${t('modules.scheduling_extend_module.headers.groups')}`,
                  `${t('modules.scheduling_extend_module.headers.participants')}`,
                  `${t('modules.scheduling_extend_module.headers.startDate')}`,
                  `${t('modules.scheduling_extend_module.headers.endDate')}`,
                  `${t('modules.scheduling_extend_module.headers.satisfaction')}`,
                  'Informes'
                ]}
                keys={['metadata.service_id', 'program.code', 'program.name', 'duration', 'schedulingMode.name', 'participants', 'startDate', 'endDate', 'satisfactionSurveyFormated']}
                detailsKey={[]}
                pagination={props.pagination}
                onModal={null}
                onPageChange={props.onPageChange}
                hideTooltip
                rowButtons={(courseScheduling) => (
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '10px'
                    }}
                  >
                    {courseScheduling?.business_report ?
                      <TooltipComponent
                        text='Informe empresarial final'
                        className='tooltip-icon-scheduling-screen'
                      >
                        <AiOutlineCloudDownload
                          onClick={() => handleClickBusinessReport(courseScheduling)}
                          className='icon-scheduling-screen'
                        />
                      </TooltipComponent>
                    :null}
                    {courseScheduling?.partial_report ?
                      <TooltipComponent
                        text='Informe empresarial parcial'
                        className='tooltip-icon-scheduling-screen'
                      >
                        <AiOutlineCloudDownload
                          onClick={() => handleClickPartialReport(courseScheduling)}
                          className='icon-scheduling-screen'
                        />
                      </TooltipComponent>
                    :null}
                  </div>
                )}
              />
            </>
          ): (
            <AlertComponent
              type='warning'
              title={t('modules.scheduling_extend_module.no_data')}
            />
          )}
          </>
        )}

        <ModalAttached
          open={openBusinessReport !== undefined}
          onClose={() => updateOpenBusinessReport(undefined)}
          defaultValue={openBusinessReport?.business_report}
          title="Informe empresarial final"
          category='business_report'
          disabled
        />

        <ModalAttached
          open={openPartialReport !== undefined}
          onClose={() => updateOpenPartialReport(undefined)}
          defaultValue={openPartialReport?.partial_report}
          title="Informe empresarial parcial"
          category='partial_report'
          disabled
        />
      </div>
    </div>
  )
}

export default SchedulingExtendModuleLayout
